import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { useDispatch } from 'react-redux';
import { WidgetBody } from '../../../components/Authentication/components/WidgetBody.js';
import { resetErrors as resetApiErrors } from '../../../components/Authentication/redux/actions.js';
import { useAuthentication } from '../../../hooks/index.js';
import { ContentLayer } from '../../../primitives/index.js';
import { AUTHENTICATION_QA_ID, qaId } from '../../../utils/qaId.js';
export const WidgetLayout = /*#__PURE__*/_styled(({
  children,
  widget,
  onCloseClick,
  title,
  ...restProps
}) => {
  const {
    toggleWidget,
    isComponentOpen
  } = useAuthentication();
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation('authentication');
  const handleCloseDialog = () => {
    dispatch(resetApiErrors());
    onCloseClick?.();
    toggleWidget(widget);
  };
  return _jsx(ContentLayer, {
    title: title,
    visuallyHideTitle: true,
    closeButtonLabel: t('closeDialog'),
    "data-testid": qaId(AUTHENTICATION_QA_ID, `${widget}-widget`),
    open: isComponentOpen('widget', widget),
    onClose: handleCloseDialog,
    small: true,
    ...restProps,
    children: _jsx(WidgetBody, {
      children: children
    })
  });
}, process.env.NODE_ENV === "production" ? {
  target: "e14dwvr70"
} : {
  target: "e14dwvr70",
  label: "WidgetLayout"
})(process.env.NODE_ENV === "production" ? {
  name: "1f3elew",
  styles: "width:100%;max-width:400px"
} : {
  name: "1f3elew",
  styles: "width:100%;max-width:400px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});